import React from 'react';

interface TimeRangeSelectorProps {
  timeRange: { start: Date; end: Date };
  onTimeRangeChange: (range: { start: Date; end: Date }) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  timeRange,
  onTimeRangeChange
}) => {
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStart = new Date(e.target.value);
    onTimeRangeChange({
      start: newStart,
      end: timeRange.end
    });
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEnd = new Date(e.target.value);
    onTimeRangeChange({
      start: timeRange.start,
      end: newEnd
    });
  };

  const setPreset = (days: number) => {
    const end = new Date();
    const start = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
    onTimeRangeChange({ start, end });
  };

  return (
    <div className="space-y-3">
      <div className="flex space-x-2">
        <button 
          onClick={() => setPreset(30)}
          className="btn-secondary text-xs py-1 px-2"
        >
          30 days
        </button>
        <button 
          onClick={() => setPreset(90)}
          className="btn-secondary text-xs py-1 px-2"
        >
          3 months
        </button>
        <button 
          onClick={() => setPreset(365)}
          className="btn-secondary text-xs py-1 px-2"
        >
          1 year
        </button>
      </div>
      
      <div className="space-y-2">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <input 
            type="date" 
            className="input-field text-sm"
            value={timeRange.start.toISOString().split('T')[0]}
            onChange={handleStartDateChange}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
          <input 
            type="date" 
            className="input-field text-sm"
            value={timeRange.end.toISOString().split('T')[0]}
            onChange={handleEndDateChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TimeRangeSelector;